import React, { useRef, useEffect, useState } from "react";
import { Card } from "reactstrap";
import { useHistory } from "react-router-dom";
import APopover from "views/pages/manage/common/a-popover";
import AButton from "views/pages/manage/common/form-fields-mui/AButton";
import { ReactComponent as BackArrow } from "assets/img/svg/BackArrow.svg";
import AInput from "views/pages/manage/common/formFeilds/customInput/AInput";
import { FILTER__FORM_FIELDS_GLOBAL, getDropdowns, getCreateUpdateRequestBody, getUpdatedData } from './constants'
import FilterForm from "./FilterForm";
import { getFilterCount } from "views/pages/manage/edpOps/stockManagement/mastersAndMapping/onBoardingMaterialIdSetup/constant";
import { checkPermission } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import ListComponent from "./ListComponent";
import { endpoint } from "views/pages/manage/common/constant";
import { fetchAllPostPromisedData } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import { successToast } from "views/pages/manage/common/utils/methods/toasterFunctions/function";
import { getDropdownLabelsFromSelectArray } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import { fetchDeletePromisedData } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";


const ThirdPartyBankMaster = ({ userPermissions }) => {

    const isCreatePermission = checkPermission(userPermissions, "C");
    const isUpdatePermission = checkPermission(userPermissions, 'U');
    const isDeletePermission = checkPermission(userPermissions, 'D');
    const history = useHistory();

    const [filterForm, setFilterForm] = useState({
        ...FILTER__FORM_FIELDS_GLOBAL,
    });
    const [filterCount, setFilterCount] = useState(getFilterCount({ ...filterForm }));
    const [loader, setLoader] = useState(false);
    const [rows, setRows] = useState([]);
    const ref = useRef();
    const [dropdownData, setDropdownData] = useState([]);
    const [paginationInfo, setPaginationInfo] = useState({
        currentPage: 0,
        totalPage: 0,
        totalRecords: 0,
    });
    const [currPageSize, setCurrentPageSize] = useState(50);
    const [searchInput, setSearchInput] = useState("");

    const applyFilterHandler = (pageNumber = 0, reqObj = {}) => {
        const { thirdPartyCodes, banks } = reqObj;
        const newReqObj = {
            thirdPartyCodes: getDropdownLabelsFromSelectArray(thirdPartyCodes),
            banks: getDropdownLabelsFromSelectArray(banks),
        };
        fetchList(newReqObj, pageNumber, currPageSize, dropdownData);
    };


    const fetchList = async (reqObj = {}, pageNumber = 0, pageSize = currPageSize, dropdowns = dropdownData) => {
        try {
            setLoader(true);
            const resp = await fetchAllPostPromisedData(`${endpoint?.refund?.thirdPartyBankMaster?.search}?offset=${pageNumber}&pageSize=${pageSize}`, reqObj, "post");

            if (resp?.code === 200) {
                const updatedData = getUpdatedData(resp, dropdowns);
                setCurrentPageSize(pageSize);
                setRows(updatedData);
                setPaginationInfo({
                    currentPage: resp?.data?.currentPage,
                    totalPage: resp?.data?.totalPage,
                    totalRecords: resp?.data?.totalRecords,
                })
                ref.current.stopEditing();
            }
        } catch (e) {
            console.log(e);
        } finally {
            setLoader(false);
        }
    }

    const nextButtonHandler = (newPage, currPageSize) => {
        const { banks, thirdPartyCodes } = filterForm;
        const newReqObj = {
            thirdPartyCodes: getDropdownLabelsFromSelectArray(thirdPartyCodes),
            banks: getDropdownLabelsFromSelectArray(banks),
        };
        fetchList(newReqObj, newPage, currPageSize, dropdownData);
    }


    const createUpdateHandler = async (rowForm) => {
        try {
            setLoader(true);
            let method = rowForm?.isNew ? "post" : "put";
            const reqObj = getCreateUpdateRequestBody(rowForm);
            const resp = await fetchAllPostPromisedData(`${endpoint?.refund?.thirdPartyBankMaster?.create}`, reqObj, method);

            if (resp?.code === 200) {
                fetchList();
                successToast("Request completed successfully!!!");
                ref.current.stopEditing();
            }
        } catch (e) {
            console.log(e);
        } finally {
            setLoader(false);
        }
    }

    const deleteHandler = async (rowData) => {
        try {
            setLoader(true);
            let resp = await fetchDeletePromisedData(`${endpoint?.refund?.thirdPartyBankMaster?.delete}/${rowData?.id}`)

            if (resp?.code === 200) {
                fetchList({}, paginationInfo?.currentPage, currPageSize, dropdownData);
                successToast('Request completed successfully!!!')
                ref.current.stopEditing();
            }
        } catch (e) {
            console.log(e);
        } finally {
            setLoader(false);
        }
    }

    const searchInputHandler = (value = searchInput) => {
        const req = {
            thirdPartyCodes: value === "" ? [] : [value]
        }
        setFilterForm((prev) => ({ ...prev, searchByValue: value }));
        fetchList(req, 0, currPageSize, dropdownData);
    }

    const onKeyDownHandler = (e) => {
        if (e.key === "Enter" || e.keyCode === 13) {
            searchInputHandler();
        }
    };

    const handleOnUserInput = (value) => {
        setSearchInput(value);

        if (value === "" && value !== filterForm?.searchByValue)
            searchInputHandler(value);
    }

    const crossHandler = () => {
        setFilterForm((prev) => ({ ...prev, searchByValue: "" }));
        setSearchInput("");
        applyFilterHandler();
    }

    const init = async () => {
        try {
            setLoader(true);
            const dropdowns = await getDropdowns();
            setDropdownData(dropdowns);
            fetchList({}, 0, 50, dropdowns);
        } catch (e) {
            console.log(e);
        } finally {
            setLoader(false);
        }
    }

    useEffect(() => {
        init();
    }, [])



    return (
        <Card className="mx-2">
            <div className="d-flex justify-content-between my-3 mx-2">
                <div className="d-flex justify-content-between">
                    <BackArrow
                        className="color-black mr-2 cursor"
                        onClick={() => history.goBack()}
                    />
                    <h4 className="color-black">Third party bank accounts</h4>
                </div>
                <div className="d-flex justify-content-between">
                    <div style={{ width: "fit-content" }}>
                        <AInput
                            style={{ width: '320px', height: '30px' }}
                            value={searchInput}
                            handler={handleOnUserInput}
                            crossIcon={true}
                            rightSearchIcon={true}
                            placeholder="Search for third party name"
                            searchIconClickHandler={(value) => { searchInputHandler() }}
                            onKeyDown={onKeyDownHandler}
                            crossHandler={crossHandler}

                        />
                    </div>
                    <APopover
                        buttonComponent={(onClick, styles) => (
                            <AButton
                                className="tiny-semi-bold color-dark"
                                onClick={onClick}
                                updatedStyle={{
                                    minWidth: "61px",
                                    ...(filterCount > 0
                                        ? {
                                            border: "1px solid #00B0F5",
                                            color: "#00B0F5",
                                        }
                                        : styles),
                                }}
                            >
                                Filters {filterCount > 0 && <>( {filterCount} )</>}
                            </AButton>
                        )}
                        menuComponent={(closePopup) => (
                            <FilterForm
                                closePopup={closePopup}
                                dropdownData={dropdownData}
                                filterForm={filterForm}
                                filterCount={filterCount}
                                setFilterCount={setFilterCount}
                                setFilterForm={setFilterForm}
                                applyFilterHandler={applyFilterHandler}
                            />
                        )}
                    />
                    <AButton
                        variant="primary_filled"
                        onClick={() => ref.current.addNewRow()}
                        size="xs"
                        disabled={!isCreatePermission}
                    >
                        + Add
                    </AButton>
                </div>
            </div>

            <ListComponent
                rows={rows}
                ref={ref}
                loading={loader}
                setLoading={setLoader}
                currentPage={paginationInfo.currentPage}
                totalRecords={paginationInfo.totalRecords}
                currPageSize={currPageSize}
                nextButtonHandler={nextButtonHandler}
                dropdownData={dropdownData}
                createUpdateHandler={createUpdateHandler}
                deleteHandler={deleteHandler}
                isUpdatePermission={isUpdatePermission}
                isDeletePermission={isDeletePermission}
            />
        </Card>
    )
}

export default ThirdPartyBankMaster;